<template>
  <svg version="1.0" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
       viewBox="0 0 1280 1280" style="enable-background:new 0 0 1280 1280;" xml:space="preserve">
    <metadata>
      Created by potrace 1.15, written by Peter Selinger 2001-2017
    </metadata>
    <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" vector-effect="non-scaling-stroke">
      <path d="M5972 12783 c-6 -12 10 -243 45 -646 31 -345 52 -631 49 -635 -4 -4
        -85 -10 -181 -14 -1152 -47 -2215 -387 -3110 -996 -917 -623 -1651 -1548
        -2075 -2612 -227 -570 -358 -1121 -411 -1735 -16 -181 -16 -630 0 -810 16
        -188 51 -427 64 -443 6 -7 18 -12 28 -10 10 2 228 180 485 397 l467 393 51
        -15 c28 -8 121 -37 206 -65 85 -28 225 -73 310 -100 85 -28 268 -87 405 -131
        138 -45 257 -81 266 -81 24 0 42 26 36 52 -17 70 -28 408 -18 575 46 782 289
        1443 747 2032 101 130 327 363 454 468 550 455 1218 724 2005 807 77 8 171 17
        208 19 l68 3 -6 -41 c-3 -22 -26 -265 -51 -540 -25 -275 -54 -590 -64 -700
        -25 -269 -19 -278 107 -166 562 496 1345 1669 1598 2391 43 123 42 129 -15
        299 -212 627 -825 1530 -1477 2174 -82 81 -157 147 -166 147 -9 0 -20 -8 -25
        -17z"/>
      <path d="M8254 11017 c-2 -7 38 -287 89 -623 52 -335 94 -609 93 -610 -171
        -144 -974 -841 -979 -851 -5 -8 -6 -20 -4 -27 3 -8 74 -49 159 -93 997 -517
        1690 -1439 1871 -2488 35 -200 41 -286 42 -545 0 -507 -79 -903 -285 -1420
        -72 -182 -218 -473 -232 -464 -7 4 -276 203 -598 443 -322 239 -592 436 -601
        438 -8 3 -21 -3 -28 -11 -11 -13 -10 -33 4 -113 136 -760 756 -2080 1244
        -2651 41 -48 53 -55 126 -76 275 -82 587 -111 1090 -103 578 10 1121 77 1625
        202 207 51 240 65 226 100 -3 8 -260 141 -572 295 -312 154 -570 283 -573 286
        -3 3 3 20 13 37 10 18 58 106 107 197 729 1359 922 2821 558 4219 -379 1453
        -1348 2755 -2624 3523 -237 143 -662 348 -721 348 -13 0 -27 -6 -30 -13z"/>
      <path d="M2115 4963 c-256 -10 -521 -38 -705 -75 -104 -20 -105 -21 -163 -77
        -435 -419 -1015 -1630 -1223 -2552 -29 -130 -29 -126 -4 -139 18 -10 84 34
        544 363 l523 374 131 -197 c484 -730 1057 -1310 1732 -1752 1176 -771 2608
        -1064 4049 -827 916 150 1788 514 2466 1029 172 130 215 169 215 195 0 28 61
        4 -630 245 -289 101 -530 188 -536 194 -6 6 -73 288 -149 626 -75 338 -142
        623 -147 633 -15 29 -45 20 -121 -37 -343 -253 -830 -478 -1267 -585 -304 -74
        -498 -96 -840 -96 -286 1 -399 11 -630 56 -753 148 -1434 561 -1981 1204 -141
        165 -349 448 -338 460 3 2 304 146 670 319 365 173 668 322 674 330 26 41 -22
        63 -293 132 -516 130 -1331 204 -1977 177z"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "ReuseIcon"
  }
</script>

<style scoped>

</style>
